import { LEGAL } from "@/data/content";

export default function Legal({ type }) {
  const doc = LEGAL[type] || LEGAL.privacy;
  return (
    <>
      <section className="page-hero" data-testid={`${type}-hero`}>
        <div className="eyebrow gold">Bima Bachat Bazar</div>
        <h1>{doc.title}</h1>
        {doc.updated && <p>{doc.updated}</p>}
      </section>
      <section className="section legal-body" data-testid={`${type}-content`}>
        {doc.sections.map(([heading, text], i) => (
          <div className="legal-block" key={i}>
            {heading && <h2>{heading}</h2>}
            <p>{text}</p>
          </div>
        ))}
      </section>
    </>
  );
}
